/**
 * Project panel
 * navModel.js
 * Created by stefensuhat on 2019-01-17 21:29
 */


export default {
    name: 'nav',
    state: { openLeft: true, openRight: false },
    reducers: {
        toggleNav: (state, open = null) => ({
            ...state,
            openLeft: open == null ? !state.openLeft : open,
            openRight: false,
        }),
        toggleRightDrawer: (state, open) => ({
            ...state,
            openLeft: false,
            openRight: open,
        }),
    },
};
